var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86353 10.6818C3.86353 9.9287 4.47405 9.31818 5.22716 9.31818H6.5908H13.409H14.7726C15.5257 9.31818 16.1363 9.9287 16.1363 10.6818V16.1364C16.1363 16.8895 15.5257 17.5 14.7726 17.5H5.22716C4.47405 17.5 3.86353 16.8895 3.86353 16.1364V10.6818Z",
    fill: "#95A1AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.409 9.31818H14.7726C15.5257 9.31818 16.1363 9.9287 16.1363 10.6818V16.1364C16.1363 16.8895 15.5257 17.5 14.7726 17.5H5.22716C4.47405 17.5 3.86353 16.8895 3.86353 16.1364V10.6818C3.86353 9.9287 4.47405 9.31818 5.22716 9.31818H6.5908M13.409 9.31818H6.5908M13.409 9.31818V5.90909C13.409 4.0263 11.8827 2.5 9.99989 2.5C8.1171 2.5 6.5908 4.0263 6.5908 5.90909V9.31818",
    stroke: "#95A1AC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSolid);
export default __webpack_public_path__ + "static/media/lock-solid.a11cbdc7791f2b0d212a6ce801622030.svg";
export { ForwardRef as ReactComponent };